export default __webpack_public_path__ + "static/media/hip21.36defd02.png";